module.exports = __webpack_public_path__ + "static/media/logo.4ced6f52.png";